/* tslint:disable */
/* eslint-disable */
/**
 * Statistics API
 * API for retrieving dashboard statistics (goals, charts, market data)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Trend direction for KPI comparison (1 Up, 2 Down, 3 Stable)
 * @export
 */
export const KpiTrendEnum = {
    Up: 1,
    Down: 2,
    Stable: 3
} as const;
export type KpiTrendEnum = typeof KpiTrendEnum[keyof typeof KpiTrendEnum];


export function instanceOfKpiTrendEnum(value: any): boolean {
    for (const key in KpiTrendEnum) {
        if (Object.prototype.hasOwnProperty.call(KpiTrendEnum, key)) {
            if (KpiTrendEnum[key as keyof typeof KpiTrendEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function KpiTrendEnumFromJSON(json: any): KpiTrendEnum {
    return KpiTrendEnumFromJSONTyped(json, false);
}

export function KpiTrendEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): KpiTrendEnum {
    return json as KpiTrendEnum;
}

export function KpiTrendEnumToJSON(value?: KpiTrendEnum | null): any {
    return value as any;
}

export function KpiTrendEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): KpiTrendEnum {
    return value as KpiTrendEnum;
}

